module.exports = __webpack_public_path__ + "static/img/conveyor-lift-mk-4_256.423ca3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-lift-mk-4_256.png
// module id = Mgzi
// module chunks = 0